import { Collapsible as CollapsiblePrimitive } from '@base-ui-components/react/collapsible';
import { css, StyleSheet } from 'aphrodite';
import React from 'react';

function Collapsible({ ...props }: React.ComponentProps<typeof CollapsiblePrimitive.Root>) {
	return <CollapsiblePrimitive.Root data-slot='collapsible' {...props} />;
}

function CollapsibleTrigger({ ...props }: React.ComponentProps<typeof CollapsiblePrimitive.Trigger>) {
	return <CollapsiblePrimitive.Trigger data-slot='collapsible-trigger' {...props} />;
}

function CollapsiblePanel({
	styles = [],
	children,
	...props
}: AphroditeStyled<React.ComponentProps<typeof CollapsiblePrimitive.Panel>>) {
	return (
		<CollapsiblePrimitive.Panel data-slot='collapsible-content' className={css(s.panel, ...styles)} {...props}>
			{children}
		</CollapsiblePrimitive.Panel>
	);
}

export { Collapsible, CollapsiblePanel, CollapsibleTrigger };

const s = StyleSheet.create({
	panel: {
		overflow: 'hidden',
		height: 'var(--collapsible-panel-height)',
		transition: 'all 150ms ease-out',
		':is([data-ending-style])': {
			height: 0,
		},
		':is([data-starting-style])': {
			height: 0,
		},
	},
});
